import { render, staticRenderFns } from "./ConversationMessageCreatedNotification.vue?vue&type=template&id=56be2aef"
import script from "./ConversationMessageCreatedNotification.vue?vue&type=script&lang=js"
export * from "./ConversationMessageCreatedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports